import React from 'react'
import { useNavigate } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import RoomItemForm from '../../components/MangeHKT/RoomItemForm'

function CreateRoomItem() {
    const navigate = useNavigate()

    // handleGoBack
    const handleGoBack = () => {
        navigate(-1)
    }
    
    // create action
    const handleForm = async (propsData) => {
        const { property, roomItemDescription,roomItemName,roomItemType, status } = propsData
        if (property) {
            try {
                const response = await nbrApi.get(`/createroomitem?properties_id=${property}&rity_id=${roomItemType}&item_name=${roomItemName}&item_description=${roomItemDescription}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Room Item created successful',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack();
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error.message)
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Room Item Create failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Room Item Create failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Create Room Item</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'><i className='fa fa-undo' /> Go Back</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <RoomItemForm handleAction={handleForm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateRoomItem